export const stationRank = [
  { label: "Kryeqytet", value: 1 },
  { label: "Qytet me rëndësi", value: 2 },
  { label: "Qytezë", value: 3 },
  { label: "Fshat", value: 4 }
];
